if (!customElements.get('comparative-element')) {
  class ComparativeElement extends HTMLElement {
    constructor() {
      super();
      // Query selectors for necessary elements
      this.switcher = this.querySelector('.comparative-element__switcher');
      this.toggleText = this.querySelectorAll('.before-after__toggle-text');
      this.toggleList = this.querySelectorAll('.comparative-element__list');
      this.cardText = this.querySelectorAll('.comparative-element__card-txt');
      this.beforeElement = this.querySelector('[data-before-element]');
      this.afterElement = this.querySelector('[data-after-element]');
      this.divider = this.querySelector('.comparative-element__divider');

      this.state = false;
      this.isDragging = false;

      // Event listener for toggling elements
      this.switcher.addEventListener('change', this.toggleElements.bind(this));

      // Event listeners for dragging functionality (Mouse and Touch)
      this.beforeElement.addEventListener('mousedown', this.startDrag.bind(this));
      this.beforeElement.addEventListener('mousemove', this.onDrag.bind(this));
      window.addEventListener('mouseup', this.stopDrag.bind(this));

      // Touch events for mobile support
      this.beforeElement.addEventListener('touchstart', this.startDrag.bind(this));
      this.beforeElement.addEventListener('touchmove', this.onDrag.bind(this));
      window.addEventListener('touchend', this.stopDrag.bind(this));

      // Initial setup
      this.compareElements();
    }

    // Toggles the active state of text and list elements
    toggleElements() {
      this.toggleAttributeState(this.toggleText);
      this.toggleAttributeState(this.toggleList);
      this.state = !this.state;
    }

    // Toggles the data-active attribute for given elements
    toggleAttributeState(elements) {
      elements[0].setAttribute('data-active', this.state);
      elements[1].setAttribute('data-active', !this.state);
    }

    // Initial setup of the divider position
    compareElements() {
      this.updateDivider(50); // Center the divider at 50%
    }

    // Starts the dragging process (Handles both mouse and touch)
    startDrag(e) {
      e.preventDefault(); // Prevent any default behavior like text selection
      this.isDragging = true;
      this.onDrag(e); // Update immediately on mousedown/touchstart
    }

    // Handles the dragging movement (Supports both mouse and touch)
    onDrag(e) {
      if (this.isDragging) {
        let clientX;

        // Determine the clientX position based on mouse or touch event
        if (e.type === 'mousemove') {
          clientX = e.clientX;
        } else if (e.type === 'touchmove') {
          clientX = e.touches[0].clientX;
        }

        if (clientX) {
          // Get the bounding rectangle of the before element
          const rect = this.beforeElement.getBoundingClientRect();
          // Calculate the mouse/touch position relative to the element
          const positionX = clientX - rect.left;
          const width = rect.width;
          // Calculate the percentage based on the position
          const percentage = (positionX / width) * 100;

          // Limit the percentage to stay between 0% and 100%
          const clampedPercentage = Math.max(0, Math.min(percentage, 100));

          // Update the clip-path of the after element based on the percentage
          this.afterElement.style.clipPath = `inset(0 ${100 - clampedPercentage}% 0 0)`;
          // Update the divider position based on the percentage
          this.updateDivider(clampedPercentage);
          // Check and update the visibility of text elements
          this.checkTextVisibility(clampedPercentage);
        }
      }
    }

    // Stops the dragging process (Handles both mouse and touch)
    stopDrag() {
      this.isDragging = false;
    }

    // Updates the position of the divider
    updateDivider(percentage) {
      this.divider.style.left = `${percentage}%`;
    }

    // Checks if the divider overlaps any text elements and updates their data-active attribute
    checkTextVisibility(percentage) {
      // Calculate the position of the divider based on the percentage
      const dividerPosition = (percentage / 100) * this.beforeElement.clientWidth;

      this.cardText.forEach(textElement => {
        // Get the bounding rectangle of the text element and the before element
        const textRect = textElement.getBoundingClientRect();
        const elementRect = this.beforeElement.getBoundingClientRect();

        // Check if the divider overlaps the text element
        const isOverlapping =
          (textRect.left < elementRect.left + dividerPosition &&
            textRect.right > elementRect.left + dividerPosition);

        // Update the data-active attribute based on overlap
        textElement.setAttribute('data-active', !isOverlapping);
      });
    }
  }

  // Define the custom element
  customElements.define('comparative-element', ComparativeElement);
}
